import { Regulation, type SourcingEventDto } from "../../../autogen/bff-api";

export const runsUnderUtilities = (event: SourcingEventDto): boolean =>
  event.eventContext.type === "Public" && event.eventContext.regulation === Regulation.Forsyningsforskriften;
